import AssetHelper from "first-common/AssetHelper";
import { Howl, Howler } from 'howler';
import canAutoplay from 'can-autoplay';

export type MatchSound = 'matchCountdown' | 'matchStart' | 'autoEnd' | 'controllers' | 'countdown' | 'startTeleop' |
    'midmatchWarning' | 'endgameWarning' | 'matchEnd' | 'abortMatch' | 'unmute' | 'results'

let sounds : Record<MatchSound, Howl> | null = null;
let unlocked = true;

export function initSounds() {
    if(sounds) return;
    sounds = {
        matchCountdown: new Howl({src: AssetHelper.syncPath('audio/countdown.flac')}),
        matchStart: new Howl({src: AssetHelper.syncPath('audio/charge.flac')}),
        autoEnd: new Howl({src: AssetHelper.syncPath('audio/endauto.flac')}),
        controllers: new Howl({src: AssetHelper.syncPath('audio/controllers.flac')}),
        countdown: new Howl({src: AssetHelper.syncPath('audio/3-2-1.flac')}),
        startTeleop: new Howl({src: AssetHelper.syncPath('audio/firebell.flac')}),
        midmatchWarning: new Howl({src: AssetHelper.syncPath('audio/windchimes.flac')}),
        endgameWarning: new Howl({src: AssetHelper.syncPath('audio/whistle.flac')}),
        matchEnd: new Howl({src: AssetHelper.syncPath('audio/endmatch.flac')}),
        abortMatch: new Howl({src: AssetHelper.syncPath('audio/foghorn.flac')}),
        unmute: new Howl({src: AssetHelper.syncPath('audio/unmute.flac')}),
        results: new Howl({src: AssetHelper.syncPath('audio/results.flac')})
    }

    canAutoplay.audio().then(({result}) => {
        unlocked = result;
    })
    sounds.unmute.on('unlock', () => {
        unlocked = true;
    })
}

export default function play(sound : MatchSound) {
    if(!sounds) {
        console.error(`Tried to play sound '${sound}', but sounds must be initialized first`)
        return;
    }
    if(!unlocked) {
        console.log(`Tried to play sound '${sound}', but user interaction is required first`)
        return;
    }
    // Don't allow concurrent sounds (except for matchStart overlapping countdown)
    if(sound != 'matchStart') {
        Howler.stop()
    }
    sounds[sound].play()
}

export function getSound(sound : MatchSound) {
    if(!sounds) {
        console.error(`Tried to get sound '${sound}', but sounds must be initialized first`)
        return;
    }
    return sounds[sound]
}